import { render, staticRenderFns } from "./DeactivateShoppingPage.vue?vue&type=template&id=1fd14eea&scoped=true&"
import script from "./DeactivateShoppingPage.vue?vue&type=script&lang=js&"
export * from "./DeactivateShoppingPage.vue?vue&type=script&lang=js&"
import style0 from "./DeactivateShoppingPage.vue?vue&type=style&index=0&id=1fd14eea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd14eea",
  null
  
)

export default component.exports